import { Tab, Tabs } from "@mui/material";

const StudentSubmissionSteps = ({ activeStep, onChange, stepLabels, isArabic, visitedSteps = [] }) => {
  return (
    <Tabs
      value={activeStep}
      onChange={onChange}
      variant="fullWidth"
      TabIndicatorProps={{ sx: { display: "none" } }}
      sx={{
        mb: 4,
        backgroundColor: "#fff",
        borderRadius: 3,
        p: 1,
        "& .MuiTabs-flexContainer": {
          gap: { xs: 0.5, sm: 1 },
        },
      }}
    >
      {stepLabels.map((label, index) => {
        const isActive = activeStep === index;
        const isVisited = visitedSteps.includes(index);

        return (
          <Tab
            key={label}
            label={label}
            sx={{
              minHeight: 42,
              minWidth: 0,
              px: { xs: 0.75, sm: 2 },
              fontSize: { xs: "0.72rem", sm: "0.875rem" },
              lineHeight: 1.25,
              whiteSpace: "normal",
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 800,
              color: isActive ? "#fff" : "#111",
              bgcolor: isActive ? "#111" : isVisited ? "#FFD600" : "#EEF2F6",
              border: isVisited && !isActive ? "1px solid #E5C400" : "1px solid transparent",
              transition: "background-color .18s ease, color .18s ease",
              "&.Mui-selected": {
                color: "#fff",
              },
              "&:hover": {
                bgcolor: isActive ? "#111" : isVisited ? "#E5C400" : "#E2E8F0",
              },
            }}
          />
        );
      })}
    </Tabs>
  );
};

export default StudentSubmissionSteps;
